export default class Password {
  constructor() {
    this.init();
  }
  init() {

    $(".esf-password__icon").click(function() {

      let input = $(this).prev();
      let svg = $(this).find("use");
      let iconId = svg.attr("xlink:href")

      input.focus();

      if (iconId === "#esf-icon-show-16") {
        input.attr("type", "text");
        svg.attr("xlink:href", "#esf-icon-hide-16");
      } else {
        input.attr("type", "password");
        svg.attr("xlink:href", "#esf-icon-show-16");
      }
    });

    $(".esf-password").focusout(function() {

      let svg = $(this).next().find("use");

      $(this).attr("type", "password");
      svg.attr("xlink:href", "#esf-icon-show-16");
    });
  }
}
